module.exports = {"home":"首頁","about":"關於我們","contact":"聯繫我們","contactinfotop":"如果您對我們的遊戲有任何疑問或建議，請隨時與我們聯繫。","contactinfobottom":"客戶服務：請聯繫：texasmasterxxx@gmail.com 品牌合作：請聯繫：texasmasterxxx@gmail.com 公關諮詢：請聯繫：texasmasterinfo@gmail.com","company":"公司介紹","companyinfo":"在德州大師中，您可以自由定制屬於您自己的德州實用玩法，高自由度是我們的一大特色。在德州大師中，您可以和朋友一起一起玩定制您最喜歡的德州實體俱樂部。我們擁有國際遊戲實驗室（GLI）認證的隨機數字生成器，配合我們專業的運營團隊，確保遊戲公平、有趣。","question":"如果您對我們的遊戲有任何疑問或建議，請隨時聯繫我們。客戶服務：","pleasecontact":"請聯繫：","forbrandingcooperation":"品牌合作：","forpublicrelationshipenquiry":"公共關係查詢：","title":"德州大師，專業精緻的德州直觀！","welcometo":"歡迎來到德克薩斯大師"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/ft.json
// module id = mwed
// module chunks = 16